import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Typography,
  Button,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  TableHead,
  TableRow,
  Grid,
} from "@material-ui/core";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import Loader from "../../components/Loader";
import { getApi } from "../../services/api";

import { DISTRICTS, VILLAGES } from "../../configs/urls";

import axios from "axios";

const useStyles = makeStyles((theme) => ({
  title: {
    margin: theme.spacing(4, 0, 2),
  },
}));

export default function Villages() {
  const classes = useStyles();
  const [isRequesting, setIsRequestig] = useState(false);
  const [districts, setDistricts] = useState([]);
  const [villages, setVillages] = useState([]);
  const [selectedDistrictId, setSelectedDistrictId] = useState(1);
  const [params, setParams] = useState({ page: 0, size: 10, district_id: 1 });
  const [totalVillagesCount, setTotalDistrictsCount] = useState(0);

  useEffect(() => {
    getAllData();
  }, []); //eslint-disable-line

  useEffect(() => {
    getVillages();
  }, [params]); //eslint-disable-line

  const getAllData = () => {
    const districts = getApi(DISTRICTS, { state_id: 1 });
    const villages = getApi(VILLAGES, params);
    axios
      .all([districts, villages])
      .then((res) => {
        if (res[0] && res[0].data) {
          setDistricts(res[0].data);
        }

        if (res[1] && res[1].data) {
          setTotalDistrictsCount(res[1].meta.total);
          setVillages(res[1].data);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const loadMoreVillages = () => {
    setParams({ ...params, page: (params.page += 1) });
  };

  const getVillages = () => {
    getApi(VILLAGES, params).then(
      (res) => {
        const data = res.data || [];
        const newVillagesList = [...villages, ...data];
        setVillages(newVillagesList);
      },
      (err) => {
        console.log(err);
      }
    );
  };

  const handleDistrictChange = (event) => {
    const value = event.target.value;
    setSelectedDistrictId(value);
    setVillages([]);
    setParams({ ...params, page: 1, district_id: value });
  };

  const renderVillages = () => (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="caption table">
        <TableHead>
          <TableRow>
            <TableCell style={{ width: "10%" }}>Sr. No.</TableCell>
            <TableCell>Name</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {villages.map((village, idx) => (
            <TableRow key={idx}>
              <TableCell component="th">{idx + 1}</TableCell>
              <TableCell component="th" scope="row">
                {village.name}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {villages.length < totalVillagesCount && (
        <Grid container justify="center" style={{ padding: 20 }}>
          <Button
            variant="outlined"
            color="primary"
            className={classes.button}
            onClick={() => loadMoreVillages()}
          >
            Load More
          </Button>
        </Grid>
      )}
    </TableContainer>
  );

  return (
    <div className={classes.root}>
      <Loader isLoading={isRequesting} />
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Typography variant="h6" className={classes.title}>
              Villages
            </Typography>
            <div>
              {districts.length > 0 && (
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                  style={{ minWidth: 120, height: 70 }}
                >
                  <InputLabel id="demo-simple-select-outlined-label">
                    City
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={selectedDistrictId}
                    label="District"
                    onChange={handleDistrictChange}
                  >
                    {districts.map((district, idx) => (
                      <MenuItem key={idx} value={district.id}>
                        {district.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            </div>
          </Grid>
          {villages.length ? (
            renderVillages()
          ) : (
            <Box
              fontSize="h6.fontSize"
              m={1}
              p={{ xs: 2, sm: 2, md: 2 }}
              style={{ textAlign: "center" }}
            >
              No Villages Found
            </Box>
          )}
        </GridItem>
      </GridContainer>
    </div>
  );
}
